<template>
  <span class="text-md w-full text-gray-200 mb-1">
    <slot></slot>
  </span>
</template>
